import { authAxios } from "services";

export const fetchAll = (page) => authAxios().get(`/serviceCenters?page=${page}`);

export const fetchOptions = () => authAxios().get(`/serviceCenters/options`);

export const create = (data) => authAxios().post(`/serviceCenters`, data);

export const fetchById = (id) => authAxios().get(`/serviceCenters/${id}`);

export const deleteById = (id) => authAxios().delete(`/serviceCenters/${id}`);

export const updateById = (id, data) => authAxios().post(`/serviceCenters/${id}?_method=PUT`, data);
